var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Dollar-Coin--Streamline-Core-Gradient.svg",
    height: 14,
    width: 14,
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dollar Coin Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free Gradient/Money Shopping/dollar-coin--accounting-billing-payment-cash-coin-currency-money-finance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "url(#paint0_linear_14402_14219)",
    fillRule: "evenodd",
    d: "M14 7c0 3.866-3.134 7-7 7-3.86599 0-7-3.134-7-7 0-3.86599 3.13401-7 7-7 3.866 0 7 3.13401 7 7ZM7.62497 3.14587c0-.34517-.27982-.625-.625-.625s-.625.27983-.625.625v.66069c-.95128.03104-1.71292.81199-1.71292 1.77082 0 .83262.57976 1.55292 1.39315 1.73085l1.51402.33119c.30265.0662.51874.3346.51874.64485 0 .36465-.29567.66019-.65972.66019h-.85648c-.28626 0-.53147-.18268-.62233-.43976-.11503-.32545-.47211-.49602-.79756-.38099-.32545.11503-.49602.4721-.38099.79755.24096.68174.85844 1.18684 1.60409 1.26314v.6698c0 .3452.27982.625.625.625s.625-.2798.625-.625v-.6698c.96252-.0985 1.71299-.91211 1.71299-1.90013 0-.89723-.62468-1.67415-1.50162-1.86598L6.32232 6.0871c-.23954-.0524-.41027-.26452-.41027-.50972 0-.28817.23361-.52178.52178-.52178h.99441c.19533 0 .37019.08409.49188.22006.05717.06388.10173.13841.13046.21969.11503.32545.4721.49603.79755.381.32545-.11503.49603-.47211.381-.79756-.08407-.23786-.21358-.45352-.37759-.63678-.30784-.34394-.74036-.5765-1.22657-.62638v-.66976Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14402_14219",
    x1: 0.538,
    x2: 16.494,
    y1: 1.131,
    y2: 10.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03a85e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.ca7de61e19113205d60e032c1ed64041.svg";
export { ForwardRef as ReactComponent };